import React, { useState } from 'react'
import { Dropdown } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'
import i18n from '~/components/i18n'
import { useAuth } from '~/routes/components/AuthProvider'
import AuthService from '~/api/services/auth'
import notify from '../Notify'
import dayjs from 'dayjs'
import { StyledFlag } from './style'
import SupportService from '~/api/services/support'
import { FARMER_ROLE_SLUG } from '~/Constants'
import { getFlagSrc } from '~/utils/helpers'

const Languages: React.FC = () => {
  const { setSystemData, systemData, setSupportData, systemData: { logged: { roleSlug } } } = useAuth()
  const { t } = useTranslation()
  const language = systemData?.languages.find(language => language.id === systemData.logged.languageId)

  const [selectedLanguage, setSelectedLanguage] = useState(language)

  function getCorrectLanguageCode(languageCode) {
    switch (languageCode) {
      case 'gb':
        return 'en'
      case 'fr_BE':
        return 'fr'
      case 'nl_BE':
        return 'nl'
      default:
        return languageCode
    }
  }

  async function handleLanguageChange(languageId: number, languageCode: string) {
    try {
      await AuthService.languageUpdate(languageId)
      const correctLanguageCode = getCorrectLanguageCode(languageCode)
      setSelectedLanguage(systemData?.languages.find(language => languageId === language.id))
      dayjs.locale(correctLanguageCode)
      i18n.changeLanguage(languageCode)
      const response = await AuthService.getSystemData()
      if (roleSlug === FARMER_ROLE_SLUG) {
        const { data: supportData } = await SupportService.getSupport();
        setSupportData(supportData)
      }
      setSystemData({ ...response.data, openedLoginPopups: true })
    } catch (error) {
      if (error.response.data) {
        notify(error.response.data.message, 'error')
      } else {
        notify(t('General error'), 'error')
      }
    }
  }

  const countryFlagSrc = getFlagSrc(language.icon)

  return <Dropdown
    icon={null}
    //@ts-ignore semantic type error
    trigger={<div style={{ color: 'white', display: 'flex', alignItems: 'center', fontWeight: 'bold', gap: 10 }}>
      <StyledFlag src={countryFlagSrc} $useShadow />
      {language?.label}
    </div>}
  >
    <Dropdown.Menu>
      {systemData?.languages.map(language => {
        return <Dropdown.Item
          key={language.id}
          value={systemData?.logged.languageId}
          text={<div style={{ display: 'flex', alignItems: 'center' }}>
            <StyledFlag src={getFlagSrc(language?.icon)} />
            <div style={{ marginLeft: 5 }}>{language.label}</div>
          </div>}
          onClick={() => handleLanguageChange(language.id, language.code)}
        />
      })}
    </Dropdown.Menu>
  </Dropdown>
}
export default Languages
